import { WebinarInstructor } from "./types";

export function formatInstructorName(instructor: WebinarInstructor) {
    return [instructor.title, instructor.firstName, instructor.lastName]
        .filter(Boolean)
        .join(" ");
}
